import { jsx as _jsx } from "react/jsx-runtime";
import { between } from '@iotv/core-services';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { ActionIcons } from '../../../Iconography';
const debug = process.env.REACT_APP_DEBUG && false;
/** A low level hook to retreive data from sheets, the data is returned unmanipulated */
export const useGoogleSpreadsheetDataImport = ({ getRequest: getRequestIn, provideImportButton }) => {
    const [spreadsheetData, setSpreadsheetData] = useState(null);
    const [error, setError] = useState(null);
    const [working, setWorking] = useState(false);
    const { range, spreadsheetId, dateTimeRenderOption, valueRenderOption } = getRequestIn ?? {};
    const getSpreadsheetData = async ({ getRequest }) => {
        const result = { err: null, data: null };
        try {
            setWorking(true);
            const { result, status, statusText } = await gapi.client.sheets.spreadsheets.values.get(getRequest);
            if (between(status, 200, 203)) {
                const values = result.values ?? [];
                setSpreadsheetData(values);
                setError(null);
            }
            else {
                setError(new Error(statusText));
                setSpreadsheetData(null);
            }
        }
        catch (error) {
            console.log('Err Caught Error', error.message);
            setError(error.result.error);
            setSpreadsheetData(null);
        }
        setWorking(false);
        return result;
    };
    const WorkingSpinner = working ? _jsx(CircularProgress, { size: "1.5em" }) : null;
    /** if ImportButton is requested, it is the only element that will call getSpreadsheetData */
    const ImportButton = provideImportButton && getRequestIn ? (_jsx(Tooltip, { title: "Load data for preview and selection", placement: "top", arrow: true, children: _jsx(IconButton, { onClick: () => getSpreadsheetData({ getRequest: getRequestIn }), children: _jsx(ActionIcons.Search, {}) }) })) : null;
    useEffect(() => {
        /** if ImportButton is not requested, getSpreadsheetData will be called on every change in params (eg user chooses different sheet) */
        if (!provideImportButton) {
            if (spreadsheetId && range) {
                getSpreadsheetData({ getRequest: { spreadsheetId, range, dateTimeRenderOption, valueRenderOption } });
            }
        }
    }, [spreadsheetId, range, dateTimeRenderOption, valueRenderOption]);
    return {
        state: { spreadsheetData, setSpreadsheetData, error, setError },
        handlers: { clearError: () => setError(null) },
        components: { WorkingSpinner, ImportButton },
    };
};
